export const pagesLinks = {
    FeedRootTitle: 'Feed',

    VerifyRootTitle: 'Verify',
    
    ManagementRootTitle: 'Management',

    multicheck: '/multi-check',

    Feed: '/Feed',

    Verify: '/Verify',

    Management: '/Management',

    Search: '/Search',

    Home: '/Search',

  };